module.exports = __webpack_public_path__ + "fonts/suisseintl-book-webfont-webfont.45e94409fdcc89f101de89413eec4a12.woff2";